import { useQuery } from "urql";

import {
  DashboardStatisticsDocument,
  QueryDashboardStatisticsArgs,
} from "../../../graphql/generated.ts";

export function useDashboardStatistics(
  variables: QueryDashboardStatisticsArgs
) {
  return useQuery({
    query: DashboardStatisticsDocument,
    variables,
  });
}
